

export const TwoDayPresentation = ({ lang }) => {
  const tours = ['acatenango', 'tikalCrater', 'tikalYaxha'];
  return (
    <div className="two-day-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/twoDayTours/${tour}${lang.charAt(0).toUpperCase() + lang.slice(1)}.jpg`} className={`two-day-tour-presentation-img`} alt={tour} key={`${i}-Two-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
